export enum AccountUserRole {
  VIEWER = 'Viewer',
  CONTRIBUTOR = 'Contributor',
  ADMIN = 'Admin',
}

export type AccountUser = {
  UserRef: string;
  Role: AccountUserRole;
};
